import { createClient } from '@supabase/supabase-js'

export const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY
const isTestMode = process.env.NEXT_PUBLIC_TEST_MODE === 'true'

// In test mode, provide dummy credentials to allow build to complete
// Supabase won't actually be used since we're using test auth
const testSupabaseUrl = 'https://test.supabase.co'
const testSupabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRlc3QiLCJyb2xlIjoiYW5vbiIsImlhdCI6MTY0NTc5OTIwMCwiZXhwIjo5OTk5OTk5OTk5fQ.test'

// Check if we have valid Supabase credentials (non-empty strings)
const hasValidSupabaseConfig = supabaseUrl && supabaseAnonKey && supabaseUrl.trim() !== '' && supabaseAnonKey.trim() !== ''

if (!isTestMode && !hasValidSupabaseConfig) {
  throw new Error(
    'Missing Supabase configuration. Please set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY in the environment.',
  )
}

// Use test credentials if in test mode or if credentials are missing, otherwise use real credentials
// Note: Supabase realtime (WebSocket) is only initialized when explicitly used via .channel().subscribe()
// Since we're not using realtime features, WebSocket connections won't be established automatically
// This allows bfcache to work properly
export const supabase = createClient(
  hasValidSupabaseConfig ? supabaseUrl! : testSupabaseUrl,
  hasValidSupabaseConfig ? supabaseAnonKey! : testSupabaseKey,
)
